import Nullstack from 'nullstack';
export default function IconCarTurbine({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-car-turbine",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "11",
    cy: "13",
    r: "4"
  }), "   ", Nullstack.element("path", {
    d: "M18.86 11c.088 .66 .14 1.512 .14 2a8 8 0 1 1 -8 -8h6"
  }), "   ", Nullstack.element("path", {
    d: "M11 9c2.489 .108 4.489 .108 6 0"
  }), "   ", Nullstack.element("rect", {
    x: "17",
    y: "3",
    width: "4",
    height: "8",
    rx: "1"
  }), "   ", Nullstack.element("path", {
    d: "M11 13l-3.5 -1.5"
  }), "   ", Nullstack.element("path", {
    d: "M11 13l2.5 3"
  }), "   ", Nullstack.element("path", {
    d: "M8.5 16l2.5 -3"
  }), "   ", Nullstack.element("path", {
    d: "M11 13l3.5 -1.5"
  }), "   ", Nullstack.element("path", {
    d: "M11 9v4"
  }), " ");
}